import React from 'react';
import { Helmet } from 'react-helmet';

export default function() {
    return (
        <div className='bg-white flex-col justify-start items-center inline-flex h-screen mb-12 sm:mb-0 w-full'>
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
                <meta httpEquiv="status" content="404"/>
            </Helmet>
            <div className={'relative sm:h-[700px] w-full'}>
                <img
                    src={'/images/permacultuur/header1.jpeg'}
                    alt={'Groenten in een permacultuur tuin'}
                    className={'duration-300 object-cover h-full w-full'}
                />
                <div className='gradient-overlay gradient-overlay-white'/>
            </div>
            <div className='self-stretch flex-col justify-start items-center gap-14 flex'>
                <div className='container px-5 sm:px-12 mx-auto'>
                    <div className='mb-6 lg:mb-12'>
                        <h2 className='leading-7 text-center text-dark fade-in sm:mb-2'>Pagina niet gevonden
                        </h2>
                        <p className={'text-dark text-center fade-in'}>De pagina die je zoekt is niet meer beschikbaar, of verplaatst.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
